import moment from 'moment';

import { DATE_FORMATS } from '@app/constants';

export const generateLastMonthPeriod = () => {
  const startDate = new Date().setDate(new Date().getDate() - 30);
  const startDateInLocaleString = new Date(startDate).toLocaleDateString();
  const startDateInIso = moment(startDate).format(
    DATE_FORMATS.ISO_FORMAT_NO_TIMEZONE
  );

  const endDate = new Date();
  const endDateInLocaleString = endDate.toLocaleDateString();
  const endDateInIso = moment(endDate).format(
    DATE_FORMATS.ISO_FORMAT_NO_TIMEZONE
  );

  const fullRange = `${startDateInLocaleString}-${endDateInLocaleString}`;

  return {
    fullRange,
    startDateInIso,
    endDateInIso,
  };
};
